import axios from 'axios';

const URL = process.env.REACT_APP_BASEURL

const config = {
    baseURL: URL
}


export default axios.create(config)